import { formatCurrencyAbbreviated } from "@/App/Equities/shared/utils"

type InstrumentInfo = {
  type: "instrumentInfo" | "quote"
  field: string
  labelKey: string
  doubleWidth?: boolean
  formatter?: (input: string | number) => string
}

export const instrumentInfo: InstrumentInfo[] = [
  {
    field: "name",
    type: "instrumentInfo",
    labelKey: "instrument.name",
    doubleWidth: true,
  },
  {
    field: "marketCapitalization",
    type: "instrumentInfo",
    labelKey: "instrument.marketCapitalization",
    formatter: formatCurrencyAbbreviated,
  },
  {
    field: "exchange",
    type: "instrumentInfo",
    labelKey: "instrument.exchange",
  },
  {
    field: "askPrice",
    type: "quote",
    labelKey: "instrument.askPrice",
  },
  {
    field: "bidPrice",
    type: "quote",
    labelKey: "instrument.bidPrice",
  },
  {
    field: "industry",
    type: "instrumentInfo",
    labelKey: "instrument.industry",
    doubleWidth: true,
  },
  {
    field: "sector",
    type: "instrumentInfo",
    labelKey: "instrument.sector",
    doubleWidth: true,
  },
]
